<div class="support-page w-full min-w-0">
  <div class="mb-2" *ngIf="isStandalone">
    <app-breadcrum [data]="supportBreadcrumbs"></app-breadcrum>
  </div>
  <h1 class="text-gray-900 text-2xl font-bold leading-tight mb-6 max-md:text-xl max-md:mb-3 max-md:mt-0">
    Contact Support
  </h1>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
    <!-- Helpline -->
    <article
      class="support-card w-full p-5 sm:p-6 rounded-2xl border border-gray-200 flex flex-col justify-between gap-6 bg-white shadow-none">
      <div class="flex items-start gap-4">
        <div class="w-12 h-12 rounded-full bg-[#EBF3FC] flex items-center justify-center shrink-0">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="#1A73E8" aria-hidden="true">
            <path
              d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 3.99c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-.99-1.11z" />
          </svg>
        </div>
        <div class="min-w-0 flex flex-col gap-1">
          <h2 class="text-lg font-bold text-gray-900 leading-snug">
            Helpline Number
          </h2>
          <p class="text-sm text-gray-500 font-normal">
            Get immediate assistance from the support team.
          </p>
        </div>
      </div>

      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 mt-auto pt-2">
        <span class="text-base sm:text-lg font-bold text-gray-900">
          1800 209 7979
        </span>
        <button type="button"
          class="h-10 px-4 py-2 bg-[#0B1348] hover:bg-[#070D33] text-white text-sm font-semibold rounded-lg inline-flex items-center justify-center gap-2 transition-colors shrink-0"
          (click)="copyPhoneNumber()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
          <span>{{ isCopied ? "Copied" : "Copy Number" }}</span>
        </button>
      </div>
    </article>

    <!-- Email -->
    <article
      class="support-card w-full p-5 sm:p-6 rounded-2xl border border-gray-200 flex flex-col justify-between gap-6 bg-white shadow-none">
      <div class="flex items-start gap-4">
        <div class="w-12 h-12 rounded-full bg-[#EBF3FC] flex items-center justify-center shrink-0">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="#1A73E8" aria-hidden="true">
            <path
              d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
          </svg>
        </div>
        <div class="min-w-0 flex flex-col gap-1">
          <h2 class="text-lg font-bold text-gray-900 leading-snug">
            Email Support
          </h2>
          <p class="text-sm text-gray-500 font-normal">
            Send us detailed queries and get response.
          </p>
        </div>
      </div>

      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 mt-auto pt-2">
        <span class="text-base font-bold text-gray-900 break-all">
          Support&#64;circularity.com
        </span>
        <button type="button"
          class="h-10 px-4 py-2 bg-[#0B1348] hover:bg-[#070D33] text-white text-sm font-semibold rounded-lg inline-flex items-center justify-center gap-2 transition-colors shrink-0"
          (click)="sendEmail()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="2" y="4" width="20" height="16" rx="2"></rect>
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
          </svg>
          <span>{{ isEmailSent ? "Email Sent" : "Send Email" }}</span>
        </button>
      </div>
    </article>

    <!-- Call back -->
    <article
      class="support-card w-full p-5 sm:p-6 rounded-2xl border border-gray-200 flex flex-col justify-between gap-6 bg-white shadow-none">
      <div class="flex items-start gap-4">
        <div class="w-12 h-12 rounded-full bg-[#EBF3FC] flex items-center justify-center shrink-0">
          <svg width="24" height="24" viewBox="0 0 32 32" fill="none" stroke-width="2"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.9999 5.33317C11.9108 5.33317 8.53817 8.40114 8.05839 12.3608C8.03753 12.533 7.89378 12.6665 7.72031 12.6665H6.66657C6.36955 12.6665 6.07902 12.6943 5.79743 12.7473C5.57258 12.7896 5.35436 12.6184 5.37432 12.3904C5.85153 6.94097 10.4265 2.6665 15.9999 2.6665C21.5733 2.6665 26.1483 6.94097 26.6255 12.3905C26.6454 12.6184 26.4272 12.7897 26.2024 12.7473C25.9208 12.6943 25.6302 12.6665 25.3332 12.6665H24.2795C24.106 12.6665 23.9623 12.533 23.9414 12.3608C23.4616 8.40114 20.089 5.33317 15.9999 5.33317Z"
              fill="#307FE1" />
            <path
              d="M24.5201 27.0241C25.1436 26.5046 25.6825 25.8626 26.0643 25.1233C26.1858 24.8883 25.9718 24.6307 25.7081 24.6517C25.5844 24.6615 25.4594 24.6665 25.3332 24.6665H23.3332C23.217 24.6665 23.1043 24.71 23.0204 24.7904C22.9543 24.8537 22.8851 24.9154 22.813 24.9755C22.3563 25.3561 21.805 25.6468 21.2194 25.8197C20.9055 25.9123 20.6661 26.1863 20.6662 26.5136L20.6665 27.8979C20.6665 28.2919 21.0076 28.6023 21.3935 28.5227C22.5476 28.2846 23.6365 27.7605 24.5201 27.0241Z"
              fill="#307FE1" />
            <path
              d="M4 19.9998V17.3332C4 15.8604 5.19391 14.6665 6.66667 14.6665H8.66667C9.03486 14.6665 9.33333 14.965 9.33333 15.3332V21.9998C9.33333 22.368 9.03486 22.6665 8.66667 22.6665H6.66667C5.19391 22.6665 4 21.4726 4 19.9998Z"
              fill="#307FE1" />
            <path
              d="M28 19.9998V17.3332C28 15.8604 26.8061 14.6665 25.3333 14.6665H23.3333C22.9651 14.6665 22.6667 14.965 22.6667 15.3332V21.9998C22.6667 22.368 22.9651 22.6665 23.3333 22.6665H25.3333C26.8061 22.6665 28 21.4726 28 19.9998Z"
              fill="#307FE1" />
            <path
              d="M13.3333 27.3332C13.3333 26.2286 14.2288 25.3332 15.3333 25.3332H18C18.3682 25.3332 18.6667 25.6317 18.6667 25.9998V28.6665C18.6667 29.0347 18.3682 29.3332 18 29.3332H15.3333C14.2288 29.3332 13.3333 28.4377 13.3333 27.3332Z"
              fill="#307FE1" />
          </svg>

        </div>
        <div class="min-w-0 flex flex-col gap-1">
          <h2 class="text-lg font-bold text-gray-900 leading-snug">
            Request a Call Back
          </h2>
          <p class="text-sm text-gray-500 font-normal">
            We'll call you within 30 mins during business hours.
          </p>
        </div>
      </div>

      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 mt-auto pt-2">
        <div class="flex-1 max-w-full sm:max-w-[220px]">
          <input type="tel"
            class="w-full h-10 px-3 rounded-md border border-gray-300 text-sm font-medium text-gray-900 focus:outline-none focus:ring-1 focus:ring-blue-500"
            [(ngModel)]="mobileNumber" (input)="onMobileNumberChange()" placeholder="+91-7891234560" />
          <p *ngIf="mobileNumberError" class="text-xs text-red-600 mt-1">
            {{ mobileNumberError }}
          </p>
        </div>
        <button type="button"
          class="h-10 px-4 py-2 bg-[#0B1348] hover:bg-[#070D33] text-white text-sm font-semibold rounded-lg inline-flex items-center justify-center gap-2 transition-colors shrink-0 disabled:opacity-60"
          (click)="requestCallBack()" [disabled]="!isValidMobileNumber || !mobileNumber">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="9 12 11 14 15 10"></polyline>
          </svg>
          <span>{{ showRequestReceived ? "Request Received" : "Request Received" }}</span>
        </button>
      </div>
    </article>

    <!-- Raise query -->
    <article
      class="support-card w-full p-5 sm:p-6 rounded-2xl border border-gray-200 flex flex-col justify-between gap-6 bg-white shadow-none">
      <div class="flex items-start gap-4">
        <div class="w-12 h-12 rounded-full bg-[#EBF3FC] flex items-center justify-center shrink-0">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A73E8" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        </div>
        <div class="min-w-0 flex flex-col gap-1">
          <h2 class="text-lg font-bold text-gray-900 leading-snug">
            Raise a Query
          </h2>
          <p class="text-sm text-gray-500 font-normal">
            Submit queries for personalized help.
          </p>
        </div>
      </div>

      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 mt-auto pt-2">
        <p class="text-sm font-semibold text-gray-900 leading-tight max-w-full sm:max-w-[210px]">
          Queries related to Orders,Delivery,Platform, Products, etc.
        </p>
        <button type="button"
          class="h-10 px-4 py-2 bg-[#0B1348] hover:bg-[#070D33] text-white text-sm font-semibold rounded-lg inline-flex items-center justify-center gap-2 transition-colors shrink-0"
          (click)="raiseQuery()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <span>Raise a Query</span>
        </button>
      </div>
    </article>
  </div>
</div>


<!-- Query Popup - Slides in from right -->
<div *ngIf="showQueryPopup"
  class="fixed inset-0 z-50 flex items-center justify-end bg-black bg-opacity-50 backdrop-blur-sm transition-all duration-300 ease-in-out"
  (click)="closeQueryPopup()">
  <div
    class="query-popup-slide-in w-full sm:w-[484px] max-w-full bg-white rounded-l-lg shadow-2xl flex flex-col h-full max-h-screen overflow-y-auto"
    (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex justify-between items-center px-6 py-4 border-b border-gray-300">
      <h2 class="text-2xl font-bold text-Primary-Deep-Blue">Raise a Query</h2>
      <button type="button" class="close-button p-1 rounded hover:bg-gray-100 transition-colors"
        (click)="closeQueryPopup()">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M22.6667 9.33325L16 15.9999L9.33337 22.6666M9.33337 9.33325L16 15.9999L22.6667 22.6666"
            stroke="#0A0A5F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <!-- Query Type -->
    <div class="px-6 py-4">
      <label class="block text-sm font-bold text-gray-800 mb-1">Query Type</label>
      <!-- Desktop Custom Dropdown with smooth transition -->
      <div class="query-type-dropdown hidden md:block w-full border border-gray-300 rounded-lg bg-white relative">
        <!-- Dropdown Header -->
        <div
          class="flex items-center justify-between p-3 cursor-pointer hover:bg-gray-50 transition-colors select-none"
          [class.border-b]="isQueryTypeDropdownExpanded"
          [class.border-gray-200]="isQueryTypeDropdownExpanded"
          (click)="toggleQueryTypeDropdown()"
        >
          <span
            class="text-base"
            [ngClass]="selectedQueryType ? 'text-gray-900 font-bold' : 'text-gray-400 font-normal'"
          >
            {{ selectedQueryType || "Select a query type" }}
          </span>
          <svg
            class="w-5 h-5 text-gray-700 transition-transform duration-300 ml-2"
            [class.rotate-180]="isQueryTypeDropdownExpanded"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </div>

        <!-- Smooth Transition Dropdown Menu -->
        <div class="dropdown-smooth-wrapper" [class.expanded]="isQueryTypeDropdownExpanded">
          <div class="dropdown-smooth-inner">
            <div
              *ngFor="let option of queryTypeOptions; let last = last"
              class="p-3.5 hover:bg-gray-50 cursor-pointer transition-colors text-gray-900 font-bold text-base"
              [class.border-b]="!last"
              [class.border-gray-200]="!last"
              (click)="selectQueryType(option)"
            >
              {{ option }}
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile dropdown trigger -->
      <div
        class="w-full p-3 border border-gray-300 rounded-lg bg-white flex justify-between items-center cursor-pointer md:hidden"
        (click)="openMobileQueryTypePopup()">
        <span class="text-gray-500">{{
          selectedQueryType || "Select a query type"
          }}</span>
        <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </div>
    </div>

    <!-- Order Details - Only show when query type is selected -->
    <div *ngIf="selectedQueryType === 'Order Related'" class="px-6 py-4">
      <label class="block text-sm font-bold text-gray-800 mb-1">Order Details</label>

      <!-- Show dropdown when no order is selected -->
      <div *ngIf="!selectedOrderId" class="order-details-dropdown w-full border border-gray-300 rounded-lg bg-white">
        <!-- Desktop dropdown header -->
        <div
          class="dropdown-header hidden md:flex items-center justify-between p-3 border-b border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors"
          (click)="toggleOrderDropdown()">
          <span class="text-gray-500 text-base">Select an Order and Products</span>
          <svg class="w-5 h-5 text-gray-400 transition-transform duration-200 ml-2"
            [class.rotate-180]="isOrderDropdownExpanded" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </div>

        <!-- Mobile dropdown trigger -->
        <div
          class="dropdown-header md:hidden flex items-center justify-between p-3 border-b border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors"
          (click)="openMobileOrderPopup()">
          <span class="text-gray-500 text-base">Select an Order and Products</span>
          <svg class="w-5 h-5 text-gray-400 transition-transform duration-200 ml-2" fill="none" stroke="currentColor"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </div>

        <!-- Order List Items - Only show when expanded -->
        <div *ngIf="isOrderDropdownExpanded" class="max-h-48 overflow-y-auto animate-dropdown-expand">
          <!-- Order Item 1 -->
          <div *ngFor="let order of orderList"
            class="order-item flex items-center p-3 border-b border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer"
            (click)="selectOrder(order)">
            <div class="radio-button flex items-center justify-center w-4 h-4 mr-3">
              <div class="w-4 h-4 border-2 rounded-full transition-colors" [class]="
                  selectedOrderId === order.order_number
                    ? 'border-blue-500 bg-blue-500'
                    : 'border-gray-300 mb-8'
                "></div>
            </div>
            <div class="flex-1">
              <div class="flex justify-between items-start mb-1">
                <div class="order-info">
                  <span class="text-blue-900 font-bold text-sm whitespace-nowrap">Order # {{ order.order_number
                    }}</span>
                  <!-- <span class="order-id value text-blue-600 font-bold text-sm ml-1">{{order.order_number}}</span> -->
                </div>
                <div class="amount-section">
                  <span class="label text-gray-600 text-sm whitespace-nowrap">Total Amount :
                    <span class="value text-gray-800 font-bold text-sm">₹{{ order.invoice_amount | number: "1.2-2" }}
                    </span></span>
                  <!-- <span class="value text-gray-800 font-bold text-sm">₹{{order.invoice_amount}}</span> -->
                </div>
              </div>
              <div class="flex justify-between items-start">
                <div class="order-info">
                  <span class="label text-gray-600 text-sm whitespace-nowrap">Order Date :
                    <span class="value text-gray-800 font-bold text-sm">{{
                      order.created_dt | date: "dd MMM yyyy"
                      }}</span></span>
                  <!-- <span class="value text-gray-800 font-bold text-sm">{{order.created_dt | date:'dd MMM yyyy'}}</span> -->
                </div>
                <div class="amount-section">
                  <span class="label text-gray-600 text-sm whitespace-nowrap">Delivery Date :
                    <span class="value text-gray-800 font-bold text-sm">{{
                      order.tracking_dt | date: "dd MMM yyyy"
                      }}</span></span>
                  <!-- <span class="value text-gray-800 font-bold text-sm">{{order.tracking_dt | date:'dd MMM yyyy'}}</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Show selected order filter chip when order is selected -->
      <div *ngIf="selectedOrderId" class="w-full">
        <div
          class="FilterChip w-full max-w-md p-3 bg-sky-50 rounded-lg border border-Secondary-Blue flex flex-col gap-3">
          <!-- Order Header with Close Icon -->
          <div class="flex justify-between items-start">
            <div class="flex-1">
              <div class="flex justify-between items-start mb-1">
                <div class="order-info">
                  <span class="whitespace-nowrap text-blue-900 text-[0.875rem]">Order #<span
                      class="order-id value text-blue-900 font-bold text-[0.875rem] ml-1">{{ selectedOrderId
                      }}</span></span>
                </div>
                <div class="amount-section">
                  <span class="label text-gray-600 text-[0.875rem] whitespace-nowrap">Total Amount :
                    <span class="value text-gray-800 font-bold text-[0.875rem]">₹{{ selectedOrder?.invoice_amount |
                      number: "1.2-2" }}
                    </span></span>
                  <!-- <span class="value text-gray-800 font-bold text-[0.675rem]">
                      {{ '₹' + selectedOrder?.invoice_amount | number:'1.2-2' }}
                    </span> -->
                </div>
              </div>
              <div class="flex justify-between items-start">
                <div class="order-info">
                  <span class="label text-gray-600 text-[0.875rem]">Order Date :
                  </span>
                  <span class="value text-gray-800 font-bold text-[0.875rem]">
                    {{ selectedOrder?.created_dt | date: "dd MMM yyyy" }}
                  </span>
                </div>
                <div class="amount-section">
                  <span class="label text-gray-600 text-[0.875rem]">Delivery Date :
                  </span>
                  <span class="value text-gray-800 font-bold text-[0.875rem]">
                    {{ selectedOrder?.tracking_dt | date: "dd MMM yyyy" }}
                  </span>
                </div>
              </div>
            </div>
            <button class="ml-2 p-1 rounded hover:bg-gray-100 transition-colors" (click)="clearOrderSelection()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.1666 5.83325L9.99992 9.99992L5.83325 14.1666M5.83325 5.83325L9.99992 9.99992L14.1666 14.1666"
                  stroke="#307FE1" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>

          <!-- Items List -->
          <div class="flex flex-col gap-2">
            <div class="flex items-center gap-2 pt-2 border-t border-gray-300"
              *ngFor="let item of selectedOrder?.invoice_items">
              <div class="CheckBox relative cursor-pointer" (click)="toggleOrderLineItem(item?.order_line_id)">
                <!-- Unchecked state -->
                <svg *ngIf="!isOrderLineItemSelected(item?.order_line_id)" width="20" height="20" viewBox="0 0 20 20"
                  fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.50008 18.3334H12.5001C16.6667 18.3334 18.3334 16.6667 18.3334 12.5001V7.50008C18.3334 3.33341 16.6667 1.66675 12.5001 1.66675H7.50008C3.33341 1.66675 1.66675 3.33341 1.66675 7.50008V12.5001C1.66675 16.6667 3.33341 18.3334 7.50008 18.3334Z"
                    fill="white" stroke="#D4D4D4" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <!-- Checked state -->
                <svg *ngIf="isOrderLineItemSelected(item?.order_line_id)" width="20" height="20" viewBox="0 0 20 20"
                  fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.50008 18.3334H12.5001C16.6667 18.3334 18.3334 16.6667 18.3334 12.5001V7.50008C18.3334 3.33341 16.6667 1.66675 12.5001 1.66675H7.50008C3.33341 1.66675 1.66675 3.33341 1.66675 7.50008V12.5001C1.66675 16.6667 3.33341 18.3334 7.50008 18.3334Z"
                    fill="#307FE1" stroke="#307FE1" stroke-width="1.25" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M8.33333 10L9.16667 10.8333L12.5 7.5" stroke="white" stroke-width="1.25"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="flex-1">
                <div class="text-gray-600 text-[0.675rem] font-bold">
                  {{ item?.part_desc }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Additional Details -->
    <div class="px-6 py-4">
      <label class="block text-sm font-bold text-gray-800 mb-1">
        Additional Details
        <span class="text-gray-500 font-normal">(Optional)</span>
      </label>
      <textarea class="w-full p-3 border border-gray-300 rounded-lg" id="query-description" rows="4"
        placeholder="Tell us more here about your concern"></textarea>
    </div>

    <div class="w-full flex flex-row justify-end gap-4 px-6 py-4 border-t border-gray-300 mt-auto">
      <!-- Cancel Button -->
      <button (click)="closeQueryPopup()" type="button"
        class="flex-1 p-3 rounded-lg border border-Primary-Deep-Blue text-Primary-Deep-Blue text-sm md:text-base font-bold flex justify-center items-center gap-2 hover:bg-blue-50 transition-colors">
        Cancel
      </button>

      <!-- Submit Button (Disabled) -->
      <button (click)="submitQuery()" type="submit" [disabled]="!isFormValid()" [class]="
          isFormValid()
            ? 'flex-1 p-3 rounded-lg bg-Primary-Deep-Blue text-white text-sm md:text-base font-bold cursor-pointer'
            : 'flex-1 p-3 rounded-lg bg-Primary-Deep-Blue text-white text-sm md:text-base font-bold opacity-60 cursor-not-allowed'
        ">
        Submit Query
      </button>
    </div>

    <!-- Footer -->
    <!-- <div class="flex justify-end gap-4 px-6 py-4 border-t border-gray-300 mt-auto">
       

<button 
  (click)="closeQueryPopup()"
type="button" 
class="w-full p-3 rounded-lg border border-Primary-Deep-Blue text-Primary-Deep-Blue text-base font-bold flex justify-center items-center gap-2 hover:bg-blue-50 transition-colors"
>
Cancel
</button>

        <button type="submit" class="px-4 py-2 bg-Primary-Deep-Blue text-white rounded-lg font-bold opacity-60 cursor-not-allowed" disabled>Submit Query</button>
      </div> -->
  </div>
</div>

<!-- Mobile Query Type Popup - Bottom Sheet -->
<div *ngIf="showMobileQueryTypePopup"
  class="fixed inset-0 z-50 flex items-end bg-black bg-opacity-50 backdrop-blur-sm transition-all duration-300 ease-in-out md:hidden"
  (click)="closeMobileQueryTypePopup()">
  <div class="mobile-popup-slide-up w-full bg-white rounded-t-lg shadow-2xl flex flex-col max-h-[80vh] overflow-hidden"
    (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="w-full h-12 px-4 py-3 bg-white border-b border-gray-300 flex justify-between items-center">
      <div class="text-Primary-Deep-Blue text-lg font-bold leading-normal">
        Query Type
      </div>
      <button type="button" class="p-1 rounded hover:bg-gray-100 transition-colors"
        (click)="closeMobileQueryTypePopup()">
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.1489 7.479L12.1489 12.479L7.14893 17.479M7.14893 7.479L12.1489 12.479L17.1489 17.479"
            stroke="var(--Primary-Deep-Blue, #0A0A5F)" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 px-3 py-4 bg-white flex flex-col gap-3 overflow-y-auto">
      <!-- Option 1 -->
      <div class="w-full pb-3 border-b border-gray-300 flex items-center gap-2 cursor-pointer"
        (click)="selectQueryTypeMobile('Technical or Website related')">
        <div class="RadioButton">
          <!-- Unselected state -->
          <svg *ngIf="selectedQueryType !== 'Technical or Website related'" width="20" height="21" viewBox="0 0 20 21"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.0005 1.69385C14.3136 1.6941 17.8101 5.19125 17.8101 9.50439C17.8098 13.8173 14.3134 17.3137 10.0005 17.314C5.68734 17.314 2.19019 13.8175 2.18994 9.50439C2.18994 5.1911 5.68719 1.69385 10.0005 1.69385Z"
              fill="white" stroke="#D4D4D4" stroke-width="0.743802" />
          </svg>
          <!-- Selected state -->
          <svg *ngIf="selectedQueryType === 'Technical or Website related'" width="19" height="20" viewBox="0 0 19 20"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.43802" cy="9.57815" r="7.80992" fill="white" stroke="#307FE1" stroke-width="0.743802" />
            <circle cx="9.43806" cy="9.57819" r="5.20661" fill="#307FE1" />
          </svg>
        </div>
        <div class="Text text-gray-900 text-lg font-bold leading-normal">
          Technical or Website related
        </div>
      </div>

      <!-- Option 2 -->
      <div class="w-full pb-3 border-b border-gray-300 flex items-center gap-2 cursor-pointer"
        (click)="selectQueryTypeMobile('Order Related')">
        <div class="RadioButton">
          <!-- Unselected state -->
          <svg *ngIf="selectedQueryType !== 'Order Related'" width="20" height="21" viewBox="0 0 20 21" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.0005 1.69385C14.3136 1.6941 17.8101 5.19125 17.8101 9.50439C17.8098 13.8173 14.3134 17.3137 10.0005 17.314C5.68734 17.314 2.19019 13.8175 2.18994 9.50439C2.18994 5.1911 5.68719 1.69385 10.0005 1.69385Z"
              fill="white" stroke="#D4D4D4" stroke-width="0.743802" />
          </svg>
          <!-- Selected state -->
          <svg *ngIf="selectedQueryType === 'Order Related'" width="19" height="20" viewBox="0 0 19 20" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.43802" cy="9.57815" r="7.80992" fill="white" stroke="#307FE1" stroke-width="0.743802" />
            <circle cx="9.43806" cy="9.57819" r="5.20661" fill="#307FE1" />
          </svg>
        </div>
        <div class="Text text-gray-900 text-lg font-bold leading-normal">
          Order Related
        </div>
      </div>

      <!-- Option 3 -->
      <div
        class="w-full flex items-center gap-2 cursor-pointer"
        (click)="selectQueryTypeMobile('Used Part or Scrap Related')"
      >
        <div class="RadioButton">
          <svg
            *ngIf="selectedQueryType !== 'Used Part or Scrap Related'"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0005 1.69385C14.3136 1.6941 17.8101 5.19125 17.8101 9.50439C17.8098 13.8173 14.3134 17.3137 10.0005 17.314C5.68734 17.314 2.19019 13.8175 2.18994 9.50439C2.18994 5.1911 5.68719 1.69385 10.0005 1.69385Z"
              fill="white"
              stroke="#D4D4D4"
              stroke-width="0.743802"
            />
          </svg>
          <svg
            *ngIf="selectedQueryType === 'Used Part or Scrap Related'"
            width="19"
            height="20"
            viewBox="0 0 19 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="9.43802"
              cy="9.57815"
              r="7.80992"
              fill="white"
              stroke="#307FE1"
              stroke-width="0.743802"
            />
            <circle cx="9.43806" cy="9.57819" r="5.20661" fill="#307FE1" />
          </svg>
        </div>
        <div class="Text text-gray-900 text-lg font-bold leading-normal">
          Used Part or Scrap Related
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div
      class="w-full h-14 px-3 py-1 bg-white border-t border-gray-300 flex justify-end items-center gap-4 justify-between">
      <button class="w-40 h-11 p-3 rounded-lg border border-Primary-Deep-Blue text-Primary-Deep-Blue font-bold"
        (click)="closeMobileQueryTypePopup()">
        Cancel
      </button>
      <button class="w-40 h-11 p-3 bg-Primary-Deep-Blue rounded-lg text-white font-bold"
        (click)="closeMobileQueryTypePopup()">
        Continue
      </button>
    </div>
  </div>
</div>

<!-- Mobile Order Selection Popup - Bottom Sheet -->
<div *ngIf="showMobileOrderPopup"
  class="fixed inset-0 z-50 flex items-end bg-black bg-opacity-50 backdrop-blur-sm transition-all duration-300 ease-in-out md:hidden"
  (click)="closeMobileOrderPopup()">
  <div class="mobile-popup-slide-up w-full bg-white rounded-t-lg shadow-2xl flex flex-col max-h-[80vh] overflow-hidden"
    (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="w-full h-12 px-4 py-3 bg-white border-b border-gray-300 flex justify-between items-center">
      <div class="text-Primary-Deep-Blue text-lg font-bold leading-normal">
        Select Order
      </div>
      <button type="button" class="p-1 rounded hover:bg-gray-100 transition-colors" (click)="closeMobileOrderPopup()">
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.1489 7.479L12.1489 12.479L7.14893 17.479M7.14893 7.479L12.1489 12.479L17.1489 17.479"
            stroke="var(--Primary-Deep-Blue, #0A0A5F)" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 px-3 py-4 bg-white flex flex-col gap-3 overflow-y-auto">
      <!-- Order Item 1 -->
      <div class="w-full pb-3 border-b border-gray-300 flex items-center gap-2 cursor-pointer"
        *ngFor="let order of orderList" (click)="selectOrderMobile(order)">
        <div class="RadioButton">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.0005 1.69385C14.3136 1.6941 17.8101 5.19125 17.8101 9.50439C17.8098 13.8173 14.3134 17.3137 10.0005 17.314C5.68734 17.314 2.19019 13.8175 2.18994 9.50439C2.18994 5.1911 5.68719 1.69385 10.0005 1.69385Z"
              fill="white" stroke="#D4D4D4" stroke-width="0.743802" />
          </svg>
        </div>
        <div class="flex-1">
          <div class="flex justify-between items-start mb-1">
            <div class="order-info">
              <span class="label text-gray-600 text-sm">Order #</span>
              <span class="order-id value text-blue-600 font-bold text-sm ml-1">{{ order.order_number }}</span>
            </div>
            <div class="amount-section">
              <span class="label text-gray-600 text-sm">Total Amount : </span>
              <span class="value text-gray-800 font-bold text-sm">₹{{ order.invoice_amount }}</span>
            </div>
          </div>
          <div class="flex justify-between items-start">
            <div class="order-info">
              <span class="label text-gray-600 text-sm">Order Date : </span>
              <span class="value text-gray-800 font-bold text-sm">{{
                order.created_dt | date: "dd MMM yyyy"
                }}</span>
            </div>
            <div class="amount-section">
              <span class="label text-gray-600 text-sm">Delivery Date : </span>
              <span class="value text-gray-800 font-bold text-sm">{{
                order.tracking_dt | date: "dd MMM yyyy"
                }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Order Item 2 -->
    </div>

    <!-- Footer -->
    <div class="w-full h-14 px-3 py-1 bg-white border-t border-gray-300 flex justify-end items-center gap-4">
      <button class="w-40 h-11 p-3 rounded-lg border border-Primary-Deep-Blue text-Primary-Deep-Blue font-bold"
        (click)="closeMobileOrderPopup()">
        Cancel
      </button>
      <button class="w-40 h-11 p-3 bg-Primary-Deep-Blue rounded-lg text-white font-bold"
        (click)="closeMobileOrderPopup()">
        Continue
      </button>
    </div>
  </div>
</div>